import { makeRedirectUri, refreshAsync, TokenResponse } from "expo-auth-session";
import { openAuthSessionAsync } from "expo-web-browser";
import jwtDecode from "jwt-decode";
import config from "../config";
import { CurrentUser } from "../hooks/useCurrentUser/types";

const clientId = config.authImpl === "auth0" ? config.auth0ClientId : config.oneLoginClientId;

export const discovery =
  config.authImpl === "auth0"
    ? {
        authorizationEndpoint: `https://${config.auth0Domain}/authorize`,
        tokenEndpoint: `https://${config.auth0Domain}/oauth/token`,
        revocationEndpoint: `https://${config.auth0Domain}/oauth/revoke`,
      }
    : {
        authorizationEndpoint: `${config.oneLoginIssuerUrl}/auth`,
        tokenEndpoint: `${config.oneLoginIssuerUrl}/token`,
        revocationEndpoint: `${config.oneLoginIssuerUrl}/token/revocation`,
      };

export const isTokenExpired = (expiresAt?: number) => {
  return !!expiresAt && Date.now() > expiresAt;
};

export function decodeToken(codeData: TokenResponse): CurrentUser {
  const { idToken, accessToken, refreshToken, issuedAt, expiresIn } = codeData;

  const token = (config.authImpl === "auth0" ? accessToken : idToken) || "";

  const { given_name: firstName, family_name: lastName }: { given_name: string; family_name: string } = jwtDecode(token);

  return {
    firstName,
    lastName,
    token,
    refreshToken,
    expiresAt: (issuedAt + (expiresIn || 0)) * 1000,
  };
}

export const refreshAsyncToken = async (refreshToken: string) => {
  const codeData = await refreshAsync({ clientId, refreshToken }, { tokenEndpoint: discovery.tokenEndpoint });
  return decodeToken(codeData);
};

export const schemeOptions = { scheme: config.appScheme, path: "redirect" };

export const mobileBrowserLogout = async (token?: string) => {
  const logoutRedirectUri = makeRedirectUri(schemeOptions);
  const logoutUrl =
    config.authImpl === "auth0"
      ? `https://${config.auth0Domain}/oidc/logout?post_logout_redirect_uri=${logoutRedirectUri}`
      : `${config.oneLoginIssuerUrl}/logout?post_logout_redirect_uri=${logoutRedirectUri}&id_token_hint=${token}`;
  return openAuthSessionAsync(logoutUrl, logoutRedirectUri);
};
